import React, { useState, useEffect } from 'react';
import ChartCard from "../shared/ChartCard";
import PageTitle from "../shared/PageTitle";
import { Avatar, TextField, Button, Typography, InputAdornment, IconButton } from '@mui/material';
import axios from 'axios';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';

const AkunSaya = () => {
  const API = process.env.REACT_APP_BE;
  const [selectedDocument, setSelectedDocument] = useState('pic');
  const loginvia = localStorage.getItem('loginvia');
  const [dataAkun, setDataAkun] = useState({
    nama: '',
    unitkerja: '',
    instansi: '',
    linkdokumen: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await axios.get(`${API}/api/v1/pgsql/akun`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
          }
        }).then(({ data }) => {
          setDataAkun(data.data);
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [API]);

  const updatePassword = async () => {
    try {
      if (password.length > 5 && password === confirmPassword) {
        await axios.put(`${API}/api/v1/pgsql/updatePassword`, 
          {
            password: password,
          }, 
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
          }
        ).then(() => {
          setPassword('')
          setConfirmPassword('')
          toast.success('Password Berhasil Diganti');
        });
      } else {
        toast.error('Password Gagal Diganti');
        setErrorMessage('Password harus lebih dari 5 karakter dan kedua password harus sama.');
      }
    } catch (error) {
      console.error('Error updating password:', error);
    }
  };
  

  const isPasswordValid = password.length > 5 && password === confirmPassword;

  const getInitials = (name) => {
    if (!name) return '';
    const nameParts = name.split(' ');
    const initials = nameParts.slice(0, 2).map(part => part.charAt(0)).join('');
    return initials.toUpperCase();
  };

  return (
    <div className="grid gap-6 mt-5 mb-6 grid-cols-1 xl:grid-cols-1">
      <ToastContainer/>
      <PageTitle>Akun Saya</PageTitle>
      <div className="grid gap-6 mt-5 mb-6 grid-cols-1 xl:grid-cols-2">
        <ChartCard>
          <Avatar sx={{ width: 150, height: 150, margin: 'auto', bgcolor: '#BDCFFF', fontSize: 80, color: '#6993FF' }}>
            {getInitials(dataAkun.length > 0 ? dataAkun[0].namapetugas : '')}
          </Avatar>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Button variant="text" color="success">
              Aktif
            </Button>
          </div>
          <Typography variant="h5" component="div" sx={{ marginTop: 2, textAlign: 'center' }}>
            <strong>{dataAkun.length > 0 ? dataAkun[0].namapetugas : ''}</strong>
          </Typography>
          <Typography variant="body2" component="div" sx={{ marginTop: 1, textAlign: 'center' }}>
            <strong>{dataAkun.length > 0 ? dataAkun[0].role : ''}</strong>
          </Typography>

          <>
            <TextField
              fullWidth
              label={dataAkun.length > 0 ? `NIP : ${dataAkun[0].nipbaru}` : ''}
              disabled
              size='small'
              sx={{ marginTop: '20px' }}
            />
            <TextField
              fullWidth
              label={dataAkun.length > 0 ? `Email : ${dataAkun[0].email}` : ''}
              disabled
              size='small'
              sx={{ marginTop: '20px' }}
            />
          </>
        </ChartCard>

        <ChartCard>
          <Typography variant="h6" component="div" sx={{ marginBottom: 2, textAlign: 'center' }}>
            <strong>Ganti Password</strong>
          </Typography>

          <TextField
            fullWidth
            size='small'
            label="Password Baru"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ marginTop: '20px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            size='small'
            label="Konfirmasi Password Baru"
            type={showPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ marginTop: '20px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {errorMessage && <Typography color="error" variant="body2" sx={{ marginTop: '10px' }}>{errorMessage}</Typography>}

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ marginTop: '20px' }}
            onClick={updatePassword}
            disabled={!isPasswordValid}
          >
            Submit
          </Button>
        </ChartCard>
      </div>
    </div>
  );
};

export default AkunSaya;
